import { WalletConnector } from '../types';

export abstract class BaseConnector implements WalletConnector {
  protected address: string | null = null;

  abstract connect(): Promise<string>;

  abstract sendTransaction(transaction): Promise<string>;
  abstract switchNetwork(): Promise<string>;
  async disconnect(): Promise<any> {
    this.address = null;
  }

  getAddress(): string | null {
    return this.address;
  }

  isConnected(): boolean {
    return !!this.address;
  }

  protected checkWindow(): void {
    if (typeof window === 'undefined') {
      throw new Error('Window is not defined');
    }
  }
}
